import { Link } from "react-router-dom";

export default function Features() {
  return (
    <main id="main">
      <section id="features" className="features">
        <div className="container">
          <header className="section-header">
            <h2>What We Deliver</h2>
            <p>Comprehensive digital capabilities designed to address every dimension of your business technology needs</p>
          </header>

          <div className="row">
            <div className="col-lg-6" data-aos="zoom-out" data-aos-delay="200">
              <img src="img/features.png" className="img-fluid" alt="SDtech Solutions capabilities" />
            </div>
            <div className="col-lg-6 mt-5 mt-lg-0 d-flex">
              <div className="row align-self-center gy-4">
                {[
                  { to: "/services/software-development", label: "Custom Software Development" },
                  { to: "/services/web-development", label: "Web Design & Development" },
                  { to: "/services/mobile-app-development", label: "Mobile App Development" },
                  { to: "/services/seo", label: "Search Engine Optimization" },
                  { to: "/services/social-media-marketing", label: "Social Media Marketing" },
                  { to: "/services/google-ads-ppc", label: "Google Ads & PPC Campaigns" },
                  { to: "/services/ui-ux-design", label: "UI/UX Design & Research" },
                  { to: "/services/cloud-services", label: "Cloud Infrastructure" },
                  { to: "/services/ai-ml-solutions", label: "AI & Machine Learning" },
                  { to: "/services/cybersecurity", label: "Cybersecurity Solutions" },
                ].map((item, index) => (
                  <div
                    className="col-md-6"
                    key={index}
                    data-aos="zoom-out"
                    data-aos-delay={300 + index * 100}
                  >
                    <Link to={item.to}>
                      <div className="feature-box d-flex align-items-center">
                        <i className="bi bi-check-circle-fill" style={{ color: "#0070f3", fontSize: "1.2rem" }} />
                        <h3>{item.label}</h3>
                      </div>
                    </Link>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Feature Tabs */}
          <div className="row feture-tabs" style={{ marginTop: "60px" }}>
            <div className="col-lg-6">
              <h3>
                Our technology solutions are built on a foundation of proven engineering practices, modern design principles, and data-driven strategies that deliver consistent, measurable outcomes.
              </h3>
              <ul className="nav nav-pills mb-3">
                <li>
                  <a className="nav-link active" data-bs-toggle="pill" href="#tab1">
                    Engineering
                  </a>
                </li>
                <li>
                  <a className="nav-link" data-bs-toggle="pill" href="#tab2">
                    Strategy
                  </a>
                </li>
                <li>
                  <a className="nav-link" data-bs-toggle="pill" href="#tab3">
                    Growth
                  </a>
                </li>
              </ul>
              <div className="tab-content">
                <div className="tab-pane fade show active" id="tab1">
                  <p>
                    We engineer robust, scalable software using modern architectures and industry best practices that stand the test of time.
                  </p>
                  <div className="d-flex align-items-center mb-2">
                    <i className="bi bi-check2" />
                    <h4>Modular Architecture Design</h4>
                  </div>
                  <p>
                    Our systems are built with modular, loosely coupled components that can be independently developed, tested, and scaled — reducing technical debt and enabling rapid feature development.
                  </p>
                  <div className="d-flex align-items-center mb-2">
                    <i className="bi bi-check2" />
                    <h4>Automated Testing & CI/CD</h4>
                  </div>
                  <p>
                    Every codebase includes automated test suites and continuous integration pipelines that catch bugs early, ensure code quality, and enable confident deployments multiple times per day.
                  </p>
                </div>
                <div className="tab-pane fade show" id="tab2">
                  <p>
                    Technology without strategy is just expensive experimentation. We align every technical decision with your business objectives.
                  </p>
                  <div className="d-flex align-items-center mb-2">
                    <i className="bi bi-check2" />
                    <h4>Data-Driven Decision Making</h4>
                  </div>
                  <p>
                    We implement analytics, tracking, and reporting systems that provide actionable insights into user behavior, system performance, and business metrics — enabling informed decisions at every level.
                  </p>
                  <div className="d-flex align-items-center mb-2">
                    <i className="bi bi-check2" />
                    <h4>Scalability Planning</h4>
                  </div>
                  <p>
                    From day one, we design systems that can handle ten times your current load without re-architecture — ensuring your technology supports your growth rather than hindering it.
                  </p>
                </div>
                <div className="tab-pane fade show" id="tab3">
                  <p>
                    Our digital marketing and growth engineering services turn your online presence into a predictable, scalable revenue engine.
                  </p>
                  <div className="d-flex align-items-center mb-2">
                    <i className="bi bi-check2" />
                    <h4>Conversion Rate Optimization</h4>
                  </div>
                  <p>
                    Through systematic A/B testing, heat mapping, and user journey analysis, we identify and eliminate friction points in your conversion funnels to maximize the value of every visitor.
                  </p>
                  <div className="d-flex align-items-center mb-2">
                    <i className="bi bi-check2" />
                    <h4>Full-Funnel Marketing</h4>
                  </div>
                  <p>
                    We build integrated marketing systems that attract, nurture, convert, and retain customers across search, social, email, and paid channels — providing complete visibility into your marketing ROI.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <img src="img/features-2.png" className="img-fluid" alt="SDtech engineering and strategy" />
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}